export default __webpack_public_path__ + "static/ideacollage-9320f2e2ffbfb1b460ccff086884af61.png";